import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

import { Column } from '@prisjakt/ui/list/variants';

import { TabAnchor } from '../navigation/types';

const GUTTER = layout.measurements.spacing100;
const ADJUSTING_MARGIN = '-0.4rem';

export const SearchResults = styled(Column)`
  padding: 0 ${GUTTER};
  margin-bottom: ${GUTTER};
  margin-top: ${GUTTER};
`;

export const Section = styled.div<{ $active?: boolean; $tab?: string }>(
  p => css`
    display: ${p.$active ? 'block' : 'none'};
    margin-top: ${p.$tab === TabAnchor.PRODUCTS ? ADJUSTING_MARGIN : 0};
  `
);

export const ModuleWrapper = styled.div`
  padding: 0 ${GUTTER};
`;

export const FilterWrapper = styled.div`
  ${media.mediumDown`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: ${layout.measurements.spacing050};
    margin-bottom: ${layout.measurements.spacing050};
  `}
`;
